<div class="main-content">
    <div class="main-heading">
        <span translate>ABOUT</span>
    </div>
    <div class="card">
        <div class="card-body">
            <div [innerHTML]="about"></div>
        </div>
    </div>
</div>